<template>
  <div id="app">
    <WwwDeepmedicalComCn v-if="model==='com'"/>
    <WwwDeepmedicalNetCn v-else/>
  </div>
</template>

<script>
import WwwDeepmedicalComCn from './components/www-deepmedical-com-cn.vue'
import WwwDeepmedicalNetCn from './components/www-deepmedical-net-cn.vue'

export default {
  name: 'App',
  components: {
    WwwDeepmedicalComCn,
    WwwDeepmedicalNetCn
  },
  data(){
    console.log("process.env.NODE_ENV", process.env.NODE_ENV)
    return {
      model:   process.env.NODE_ENV === 'com'? 'com' : 'net' // com、net
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
* {
  padding: 0;
  margin: 0;
}
</style>
